// @flow

import React, { type Node } from 'react';
import { getGatewayVoucherCode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import Barcode from 'react-barcode';
import styled from 'styled-components';
import { SectionTitle, SectionSubtitle, Separator } from '../../../../commons/atoms';

export function PaynetBarcode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <section>
      <SectionTitle>Datos para pago de tu cupón Paynet</SectionTitle>
      <Separator size="0.8em" />
      <SectionSubtitle>
          Presente el código en tu teléfono celular e imprímalo. También puede dictar los números al cajero
      </SectionSubtitle>
      <BarcodeWrapper>
        <Barcode format="CODE128" value={getGatewayVoucherCode(incomingPayment)} displayValue={false} height={50} />
      </BarcodeWrapper>
    </section>
  );
}

const BarcodeWrapper = styled.div`
  svg {
    width: 100%;
    height: 100%;
    margin: 0.8em 0;
  }
  width: 100%;
`;
